var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.render)?_c('div',[(_vm.menuInfo.open)?_c('GmapInfoWindow',{attrs:{"options":_vm.menuInfo.options,"position":_vm.menuInfo.position,"opened":_vm.menuInfo.open,"content":_vm.menuInfo.content},on:{"closeclick":function($event){_vm.menuInfo.open=false}}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }